import React from "react";
import { View } from "react-native";

import {
  downloadOrEmailURL,
  isWeb,
  navigate,
} from "../../../../../helpers/utils";
import Header from "../../../common/header/index";
import appStyles from "../../../../appStyles";
import AccountsList from "./AccountsList";
import appPages from "../../../../../appPages";
import IntegrationsHelper, { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import DownloadStarted from "./DownloadStarted";
import EmailSent from "./EmailSent";
import AppConfig from "../../../../../config/AppConfig";
import Disconnect from "./Disconnect";
import Reconnect from "./Reconnect";
import SnoozeIntegrationDialog from "../../common/SnoozeIntegrationDialog";

export default class ChromeSyncPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const params = this._getArgs() || {};

    if (!params.isActive && !params.reconnect && !params.disconnect) {
      // Connect on start download
      this.connect();
    }

    this.state = {
      showAccounts: params.isActive,
      reconnect: params.reconnect,
      title: params.title,
      disconnectAccount: params.disconnect,
      selectedAccount: null,
      accounts: this._getAccounts(),
    };
  }

  _getAccounts = () => {
    return this.controller.getDevices("chrome");
  };

  _getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params;
    } else {
      return this.controller.state.screenArgs?.args;
    }
  }

  goBack = () => {
    this.controller.goBack();
  };

  goToIntegrationsPage = () => {
    this.controller
      .refreshIntegrations(true)
      .then(() => navigate(this.controller, appPages.integrationsV2));
  };

  connect = (enable = true) => {
    this.setState((state) => ({ ...state, isLoading: true }));
    IntegrationsHelper.saveIntegrations(
      this.controller,
      {
        [INTEGRATION_KEYS.chrome]: enable,
      },
      () => {
        this.setState((state) => ({ ...state, isLoading: false }));
        if (enable) {
          downloadOrEmailURL(
            this.controller,
            "chrome",
            AppConfig["CHROME_DOWNLOAD_URL"],
          );
        } else {
          navigate(this.controller, appPages.integrationsV2);
        }
      },
    );
  };

  saveIntegrations = (data, redirect = false) => {
    IntegrationsHelper.saveIntegrationSource(this.controller, data, () => {
      if (redirect) {
        this.controller.getItems(appPages.integrationsV2);
      }
    });
  };

  showInstructions = () => {
    this.setState(
      (state) => ({ ...state, reconnect: false }),
      () => {
        downloadOrEmailURL(
          this.controller,
          "chrome",
          AppConfig["CHROME_DOWNLOAD_URL"],
        );
      },
    );
  };

  // ------------------------------------- SNOOZE -------------------------------------
  onCancel = (selectedAccount) => {
    const { accounts } = this.state;

    accounts.forEach((acc) => {
      if (acc.id == selectedAccount.id) acc.isEnabled = true;
    });

    this.setState((state) => ({ ...state, accounts, snoozeAccount: null }));
  };

  toggleAccountStatus = (account, isEnabled) => {
    if (!isEnabled) {
      this.setState((state) => ({ ...state, snoozeAccount: account }));
      return;
    }

    this.setState((state) => ({
      ...state,
      snoozeAccount: null,
      disconnectAccount: null,
    }));

    const data = {
      [INTEGRATION_KEYS.chrome]: isEnabled,
      account: account.email,
      id: account.id,
      isEnabled: isEnabled,
    };

    this.saveIntegrations(data);
  };

  showDisconnectPage = (acc) => {
    this.setState((state) => ({ ...state, disconnectAccount: acc }));
  };

  disconnectAccount = () => {
    const { disconnectAccount } = this.state;
    this.toggleAccountStatus(disconnectAccount, false);
  };

  showAccountsPage = () => {
    this.setState((state) => ({
      ...state,
      showAccounts: true,
      accounts: this._getAccounts(),
    }));
  };

  onDone = () => {
    const data = {
      [INTEGRATION_KEYS.chrome]: true,
      isEnabled: true,
      isConnected: true,
    };

    IntegrationsHelper.saveIntegrationSource(this.controller, data, () => {
      this.controller.getApiData("settings", {}, (settings) => {
        this.showAccountsPage();
      });
    });
  };

  confirmUninstall = () => {
    const { disconnectAccount } = this.state;
    this.saveIntegrations(
      {
        [INTEGRATION_KEYS.chrome]: false,
        disconnect: true,
        id: disconnectAccount.id,
      },
      true,
    );
  };

  editAccount = (account) => {
    if (
      IntegrationsHelper.isOldIntegration(
        account.isConnected,
        account.last_updated,
      )
    ) {
      this.setState((state) => ({ ...state, reconnect: true }));
    }
  };

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const {
      accounts,
      showAccounts,
      isLoading,
      disconnectAccount,
      snoozeAccount,
      reconnect,
      title,
    } = this.state;

    return (
      <>
        <SnoozeIntegrationDialog
          controller={this.controller}
          account={snoozeAccount}
          integrationName={INTEGRATION_KEYS.chrome}
          saveIntegrations={this.saveIntegrations}
          onCancel={this.onCancel}
        />
        {disconnectAccount ? (
          <Disconnect
            showDisconnectPage={this.showDisconnectPage}
            disconnectAccount={this.disconnectAccount}
            confirmUninstall={this.confirmUninstall}
          />
        ) : reconnect ? (
          <Reconnect
            account={title || snoozeAccount?.name}
            goBack={this.goBack}
            showInstructions={this.showInstructions}
          />
        ) : (
          <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
            <Header
              title="Chrome"
              subTitle="Get insights from your browsing activity"
              goBack={this.goBack}
              returnPage={appPages.integrationsV2}
              isLoading={isLoading}
            />

            {!showAccounts ? (
              isWeb ? (
                <DownloadStarted
                  controller={this.controller}
                  goToStep={this.goBack}
                  onButtonPress={this.onDone}
                />
              ) : (
                <EmailSent
                  controller={this.controller}
                  goToStep={this.goBack}
                  onButtonPress={this.showAccountsPage}
                />
              )
            ) : (
              <AccountsList
                controller={this.controller}
                accounts={accounts}
                disconnectAccount={this.showDisconnectPage}
                toggleAccountStatus={this.toggleAccountStatus}
                editAccount={this.editAccount}
              />
            )}
          </View>
        )}
      </>
    );
  }
}
